import React from 'react';
import clsx from 'clsx';
import { Checkbox } from '@material-ui/core';

const NewWindowCheckbox = (props) => {

    const {
        newWindowChecked,
        handleNewWindowChecked
    } = props;

    return(
        <div className={clsx('spacingTopDiv','teamSelector')} onClick={handleNewWindowChecked} aria-hidden="true">
            <span style={{display: 'inline-block', marginLeft: '2vw' }}/>
            <Checkbox checked={newWindowChecked} style={{color: '#0c4d82', transform: 'scale(0.8)'}}  inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
            <span style={{fontSize: '0.8rem'}}> Open in a new window </span> 
        </div> 
    )

}

export default NewWindowCheckbox;
